// ./src/components/lists/ListIndications/Item/index.tsx
import React, { useState } from 'react';

import { FaHistory } from 'react-icons/fa';
import { FiCornerUpRight } from 'react-icons/fi';
import {
  IoEllipsisHorizontal,
  IoCheckmarkCircle,
  IoFlag,
  IoStopCircle,
  IoCreate,
} from 'react-icons/io5';

import { Paragraph } from '@components/index';
import { ConfigStyles, ConfigTransition, ConfigValues } from '@config/index';
import transition from '@config/transition';
import Indication from '@models/Indication';
import { formatDate, formatMoney } from '@utils/formatters';
import { toastify } from '@utils/notifiers';

import {
  Container,
  CompositeItem,
  CompositeItemText,
  Dropdown,
  DropdownButton,
  DropdownItem,
} from './styles';

interface IProps {
  indication: Indication;
}

const ListIndicationsItem: React.FC<IProps> = ({ indication }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <Container onClick={() => setIsExpanded(prevState => !prevState)}>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {formatDate.addMask(indication.date.split(' ')[0])}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {indication.user_indicated?.name.toUpperCase()}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {indication?.user_indicated?.cpf || indication?.user_indicated?.cnpj}
      </Paragraph>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {indication?.user_who_indicated?.cpf ||
          indication?.user_who_indicated?.cnpj}
      </Paragraph>
      <CompositeItem>
        {ConfigValues.rebox.indication.status.effective ===
          indication?.status && (
          <IoCheckmarkCircle
            size={12}
            color={ConfigStyles.rebox.colors.greenEmerald.main}
          />
        )}

        {ConfigValues.rebox.indication.status.created === indication.status && (
          <IoFlag size={12} color={ConfigStyles.rebox.colors.lightBlue.main} />
        )}

        {ConfigValues.rebox.indication.status.canceled ===
          indication.status && (
          <IoStopCircle size={12} color={ConfigStyles.rebox.colors.gray.main} />
        )}

        <CompositeItemText>
          {
            ConfigTransition.rebox_indications_status[
              indication.status?.toLowerCase() || 'undefined'
            ]
          }
        </CompositeItemText>
      </CompositeItem>
      <Paragraph nameColor="black" textAlign="start" fontSize={12}>
        {formatMoney.fromNumberToPrice(indication.cash_bonus)}
      </Paragraph>
      <CompositeItem>
        <FaHistory
          size={11}
          color={
            indication.renewal_number === 0
              ? ConfigStyles.rebox.colors.gray.main
              : ConfigStyles.rebox.colors.lightBlue.main
          }
        />

        <CompositeItemText>{indication.renewal_number}</CompositeItemText>
      </CompositeItem>

      <Paragraph nameColor="black" className="btn-options">
        <IoEllipsisHorizontal
          size={16}
          color={ConfigStyles.rebox.colors.black.main}
          style={{ cursor: 'pointer' }}
        />
      </Paragraph>
      <Dropdown expande={isExpanded}>
        {/* <DropdownItem to={`/usuarios/clientes/${indication.id}`}>
          <IoCreate
            size={16}
            title="ícone de editar"
            color={ConfigStyles.rebox.colors.black.main}
          />
          <Paragraph
            nameColor="black"
            textAlign="start"
            fontSize={11}
            style={{
              marginLeft: '1vw',
              fontWeight: 500,
            }}
          >
            Editar
          </Paragraph>
        </DropdownItem> */}

        <DropdownItem to={`/usuarios/afiliados/indicacoes/${indication.id}`}>
          <FiCornerUpRight
            size={16}
            title="ícone de editar"
            color={ConfigStyles.rebox.colors.black.main}
          />
          <Paragraph
            nameColor="black"
            textAlign="start"
            fontSize={11}
            style={{
              marginLeft: '1vw',
              fontWeight: 500,
            }}
          >
            Abrir
          </Paragraph>
        </DropdownItem>
      </Dropdown>
    </Container>
  );
};

export default ListIndicationsItem;
